import React from 'react';
import { Field, Modal } from '../../components/ui';

const findField = (fields, key) => fields.find(field => field.key === key) || { key, label: key };

// Phone / APK event form: full screen, thumb-sized. Who runs the event is a
// two-button switch (Existing user | New user) instead of a dropdown; the
// new user's mobile opens the number pad. Save at the bottom.
export default function EventFormMobile({ vm }) {
  const { open, editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!open) return null;

  const adminMode = values.EventAdminMode || 'Existing User';
  const eventName = findField(fields, 'EventName');
  const eventType = findField(fields, 'EventTypeId');
  const adminModeField = findField(fields, 'EventAdminMode');
  const existingAdmin = findField(fields, 'EventAdminUserId');
  const newAdminName = findField(fields, 'EventAdminName');
  const newAdminMobile = findField(fields, 'EventAdminMobileNumber');
  const newAdminPassword = findField(fields, 'EventAdminPassword');
  const modes = adminModeField.options && adminModeField.options.length ? adminModeField.options : ['Existing User', 'New User'];

  return (
    <Modal
      fullScreen
      className="ev-m"
      title={`${editing ? 'Edit' : 'Add'} Event`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <Field label="Event Name" value={values.EventName} required onChange={(value) => setField(eventName, value)} />
      <Field label="Event Type" type="select" value={values.EventTypeId} options={eventType.options} required
        onChange={(value) => setField(eventType, value)} />

      <div className="field">Event Admin *
        <div className="ev-seg" role="group" aria-label="Event Admin" style={{ marginTop: 4 }}>
          {modes.map(m => {
            const v = m.value ?? m;
            return (
              <button key={v} type="button" className={adminMode === v ? 'on' : ''} style={{ padding: '11px 6px', fontSize: 14 }}
                onClick={() => setField(adminModeField, v)}>{m.label ?? m}</button>
            );
          })}
        </div>
      </div>

      {adminMode === 'Existing User' ? (
        <Field label="Existing User" type="select" value={values.EventAdminUserId} options={existingAdmin.options} required
          onChange={(value) => setField(existingAdmin, value)} />
      ) : (
        <>
          <Field label="New User Name" value={values.EventAdminName} required onChange={(value) => setField(newAdminName, value)} />
          <div className="ev-m-pair">
            <label className="field">Mobile *
              <input type="tel" inputMode="numeric" value={values.EventAdminMobileNumber ?? ''} placeholder="10 digits"
                onChange={(e) => setField(newAdminMobile, e.target.value)} />
            </label>
            <label className="field">Password
              <input value={values.EventAdminPassword || '1234'} onChange={(e) => setField(newAdminPassword, e.target.value)} />
            </label>
          </div>
        </>
      )}
    </Modal>
  );
}
